import i18next from 'i18next';

import { COUNTRY_FRANCE_TYPO, ISO_FRANCE, USER_LANGUAGE_CODE } from '../constants/country';

import { getCountry } from 'countries-and-timezones';

// The platform stores Chinese as 'cn', but BCP 47 locales (used by Intl) expect 'zh'
const INTL_LOCALE_BY_LANGUAGE_CODE = {
  [USER_LANGUAGE_CODE.CN]: 'zh',
};

const convertCountry = (country) => {
  if (COUNTRY_FRANCE_TYPO.includes(country)) {
    return ISO_FRANCE;
  }

  return country;
};

export const getIsoCountryCode = (country) => {
  if (country.length === 2) {
    return country;
  }

  const countryData = getCountry(convertCountry(country));

  return countryData.id;
};

/**
 * Display name of an ISO 3166-1 alpha-2 country code, localized in the current user language.
 * Falls back to the raw value when Intl cannot resolve it — legacy data can hold a full country
 * name instead of a code.
 *
 * @param {string} countryCode - The ISO 3166-1 alpha-2 code (e.g. 'FR')
 *
 * @returns {string} The localized country name, or the raw value when it cannot be resolved
 */
export const getCountryName = (countryCode) => {
  if (!countryCode) {
    return countryCode;
  }

  const languageCode = i18next.language;

  const locale = INTL_LOCALE_BY_LANGUAGE_CODE[languageCode] ?? languageCode;

  try {
    const displayNames = new Intl.DisplayNames([locale], { type: 'region' });

    return displayNames.of(countryCode.toUpperCase()) ?? countryCode;
  } catch {
    return countryCode;
  }
};

export default {
  getIsoCountryCode,
  getCountryName,
};
